(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cc-frido-style-product"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-cc-gallery]').forEach(function(gallery) {
    var slides = gallery.querySelectorAll('[data-cc-slide]');
    var thumbs = gallery.querySelectorAll('[data-cc-thumb]');
    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        var index = thumb.getAttribute('data-cc-thumb');
        slides.forEach(function(slide) {
          slide.classList.toggle('is-active', slide.getAttribute('data-cc-slide') === index);
        });
        thumbs.forEach(function(item) {
          item.classList.toggle('is-active', item === thumb);
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-video-block"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.product-video-block').forEach(function (section) {
    var row = section.querySelector('.product-video-block__row');
    var videos = section.querySelectorAll('.product-video-block__video');

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target;

          if (entry.isIntersecting) {
            video.muted = true;
            video.loop = true;
            video.play().catch(function () {});
          } else {
            video.pause();
          }
        });
      }, {
        root: row,
        threshold: 0.45
      });

      videos.forEach(function (video) {
        observer.observe(video);
      });
    } else {
      videos.forEach(function (video) {
        video.muted = true;
        video.loop = true;
        video.play().catch(function () {});
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uploaded-video-gallery"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.manual-upload-video-gallery').forEach(function (gallery) {
    var row = gallery.querySelector('.manual-upload-video-gallery__row');
    var left = gallery.querySelector('.manual-upload-video-gallery__arrow--left');
    var right = gallery.querySelector('.manual-upload-video-gallery__arrow--right');
    var videos = gallery.querySelectorAll('.manual-upload-video-gallery__preview');

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target;

          if (entry.isIntersecting) {
            video.muted = true;
            video.loop = true;
            video.play().catch(function () {});
          } else {
            video.pause();
          }
        });
      }, {
        root: row,
        threshold: 0.45
      });

      videos.forEach(function (video) {
        observer.observe(video);
      });
    } else {
      videos.forEach(function (video) {
        video.muted = true;
        video.loop = true;
        video.play().catch(function () {});
      });
    }

    left.addEventListener('click', function () {
      row.scrollBy({ left: -260, behavior: 'smooth' });
    });

    right.addEventListener('click', function () {
      row.scrollBy({ left: 260, behavior: 'smooth' });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
